"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootScopeProvider = exports.smartServiceDeliveryProvider = void 0;
const angularjs_service_upgrade_enum_1 = require("./angularjs-service-upgrade.enum");
function smartServiceDeliveryFactory(injector) {
    return injector.get(angularjs_service_upgrade_enum_1.AngularJsServiceUpgradeType.SMART_SERVICE_DELIVERY);
}
function rootScopeFactory(injector) {
    return injector.get(angularjs_service_upgrade_enum_1.AngularJsServiceUpgradeType.ROOT_SCOPE);
}
//this provider should be included in NgModule, where service needs to be used
exports.smartServiceDeliveryProvider = {
    provide: angularjs_service_upgrade_enum_1.ANGULARJS_SERVICE_UPGRADE_TOKENS.SMART_SERVICE_DELIVERY_TOKEN,
    useFactory: smartServiceDeliveryFactory,
    deps: ['$injector']
};
exports.rootScopeProvider = {
    provide: angularjs_service_upgrade_enum_1.ANGULARJS_SERVICE_UPGRADE_TOKENS.ROOT_SCOPE_TOKEN,
    useFactory: rootScopeFactory,
    deps: ['$injector']
};
